import { useRef, useState } from "react";

// localStorage'dan taslağı ilk render'da okuruz (lazy init); effect içinde setState
// çağırmak "cascading render" uyarısı veriyordu.
function readDraft<T>(key: string, enabled: boolean): T | null {
	if (!enabled) return null;
	const raw = localStorage.getItem(key);
	if (!raw) return null;
	try {
		return JSON.parse(raw) as T;
	} catch {
		localStorage.removeItem(key);
		return null;
	}
}

export function useFormDraft<T>(key: string, enabled: boolean) {
	const [pendingDraft, setPendingDraft] = useState<T | null>(() => readDraft<T>(key, enabled));
	const [resolved, setResolved] = useState(() => !enabled || readDraft<T>(key, enabled) === null);
	const saveTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

	const acceptDraft = () => {
		setPendingDraft(null);
		setResolved(true);
	};

	const discardDraft = () => {
		localStorage.removeItem(key);
		setPendingDraft(null);
		setResolved(true);
	};

	const save = (data: T) => {
		if (!enabled || !resolved) return;
		if (saveTimer.current) clearTimeout(saveTimer.current);
		saveTimer.current = setTimeout(() => {
			localStorage.setItem(key, JSON.stringify(data));
		}, 500);
	};

	const clear = () => {
		if (saveTimer.current) clearTimeout(saveTimer.current);
		localStorage.removeItem(key);
	};

	return {
		pendingDraft,
		showPrompt: enabled && !!pendingDraft && !resolved,
		acceptDraft,
		discardDraft,
		save,
		clear,
	};
}
